import {
  Divider,
  Dialog,
  DialogContent,
  Grid,
  Paper,
  styled,
  IconButton,
} from "@mui/material";
import { DialogTitle, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import { withRouter } from "../../components/withRouter";
import {
  convertMessage,
  noInternetMsg,
  saveFailedMsg,
  serverMsg,
  statusFailedMsg,
  statusmsg,
} from "../../config/messageconstant";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import endpoint from "../../config/endpoints";
import CloseIcon from "@mui/icons-material/Close";
import { blackColor } from "../../config/ColorObj";
import { getStockStakeHolderType } from "../../Slice/stockStakeHolderType.slice";
import { getBrand } from "../../Slice/brand.slice";
import { getPaymentTerm } from "../../Slice/paymentTerm.Slice";
import { AddDistributorJson } from "../../DynamicFormsJson/Transaction/addDistributor";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import {
  getDistributorInquiry,
  saveDistributorInquiry,
} from "../../Slice/distributorInquiry.slice";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../Slice/area.slice";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import {
  getTalukaByDistrict,
  getTalukaByUserType,
} from "../../Slice/taluka.slice";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import dayjs from "dayjs";
import { getStateByRegion } from "../../Slice/state.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getRegionNew } from "../../Slice/region.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

class ConvertDataPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        stakeHolderTypeDetail:
          this.props.stakeHolderTypeList?.stockStakeHolderType,
        brandDetail: this.props.brandList?.brand,
        paymentTermDetail: this.props.paymentTermList?.paymentTerm,
        talukaDetail: this.props.talukaList?.taluka,

        distributorInquiryDetail:
          this.props.distributorInquiryList?.distributorInquiry,

        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
      },
      openPopUp: false,
      fullName: "",
      areaHierarchyData: {},
      userTypeId: "",
      isNewArea: "",
      fieldData: {},
      formErrors: {},
      adminFlag: false,
    };
  }
  async componentDidMount() {
    const {
      selectedRecord,
      getBrand,
      getPaymentTerm,
      getStockStakeHolderType,
      getTalukaByUserType,
      getRegionNew,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {

      const userTypeId = localStorage.getItem("userTypeId");

      let adminFlag = userTypeId == 1 || userTypeId == 6;

      this.setState({ userTypeId, adminFlag });

      let fullName = "";
      let areaId = "";
      let isNewArea = "";

      selectedRecord.map((dataObj) => {
        fullName = dataObj.fullName;
        areaId = dataObj.currentAreaIds;
        isNewArea = dataObj.isNewArea;
        this.setState({ isNewArea });
        if (isNewArea == 1) {
          this.setState({
            fieldData: { currentAreaIds: areaId },
          });
        }
      });

      this.setState({ fullName });

      if (isNewArea == 0 && userTypeId == 3) {
        showLoador({ loador: true });
        await apiGet({
          url: endpoint.area + "/hierarchy-by-area?areaId=" + areaId,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            this.props.showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            this.setState({ areaHierarchyData: data.data });
          }
        });
      }

      if (userTypeId != 3 && isNewArea == 1) {
        showLoador({ loador: true });
        await getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }


      showLoador({ loador: true });
      await getBrand().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      if (userTypeId == 3 && isNewArea == 1) {
        showLoador({ loador: true });
        await getTalukaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      showLoador({ loador: true });
      getPaymentTerm().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getStockStakeHolderType({ userTypeIds: 2 }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({ openPopUp: true });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.brandList !== nextProps.brandList) {
      if (this.props.brandList?.brand !== nextProps.brandList?.brand) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            brandDetail: nextProps.brandList?.brand,
          },
        });
      }
    }

    if (this.props.paymentTermList !== nextProps.paymentTermList) {
      if (
        this.props.paymentTermList?.paymentTerm !==
        nextProps.paymentTermList?.paymentTerm
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            paymentTermDetail: nextProps.paymentTermList?.paymentTerm,
          },
        });
      }
    }

    if (this.props.stakeHolderTypeList !== nextProps.stakeHolderTypeList) {
      if (
        this.props.stakeHolderTypeList?.stockStakeHolderType !==
        nextProps.stakeHolderTypeList?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stakeHolderTypeDetail:
              nextProps.stakeHolderTypeList?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (this.props.talukaList?.taluka !== nextProps.talukaList?.taluka) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.taluka,
          },
        });
      }
    }

    if (
      this.props.distributorInquiryList !== nextProps.distributorInquiryList
    ) {
      if (
        this.props.distributorInquiryList?.distributorInquiry !==
        nextProps.distributorInquiryList?.distributorInquiry
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            distributorInquiryDetail:
              nextProps.distributorInquiryList?.distributorInquiry,
          },
        });
      }
    }

    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
  }

  handleClose = () => {
    const { handleCloses } = this.props;
    handleCloses();
  };

  onSave = () => {
    const {
      selectedRecord,
      showLoador,
      showNotification,
      saveDistributorInquiry,
    } = this.props;
    const { fieldData, areaHierarchyData, userTypeId, isNewArea } = this.state;
    let dataToSave = {};

    let fieldDataJson = {
      ...fieldData,
      fromDate: dayjs(fieldData.fromDate).format("DD-MM-YYYY"),
      toDate: dayjs(fieldData.toDate).format("DD-MM-YYYY"),
    }

    if (userTypeId == 3 && isNewArea == 0) {
      dataToSave = {
        ...selectedRecord[0],
        currentRegionId: areaHierarchyData.regionId,
        currentStateId: areaHierarchyData.stateId,
        currentZoneIds: areaHierarchyData.zoneId,
        currentDistrictIds: areaHierarchyData.districtId,
        currentTalukaIds: areaHierarchyData.talukaId,
        ...fieldDataJson,
      };
    } else {
      dataToSave = {
        ...selectedRecord[0],
        ...fieldDataJson,
      };
    }

    let approveJSon = {};

    selectedRecord.map((dataObj) => {
      approveJSon = {
        distributorInquiryIds: dataObj.id.split(","),
        status: "2",
        stockStakeHolderTypeId: fieldData.stockStakeHolderType,
      };
    });

    console.log(approveJSon);

    console.log(dataToSave)

    if (this.checkValidationOnSubmit()) {
      if (navigator.onLine) {
        if (isNewArea == 1) {
          swal({
            title: "Are you sure?",
            text: convertMessage,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          }).then((willDelete) => {
            if (willDelete) {
              showLoador({ loador: true });
              apiPost({
                url:
                  endpoint.distributorInquiry + "/save-with-validate-new-area",
                postBody: dataToSave,
              }).then(({ data, success }) => {
                if (success) {
                  if (data.data.statusCode == 500) {
                    showNotification({
                      msg: data.data.message,
                      severity: "error",
                    });
                  } else {
                    showLoador({ loador: true });

                    apiPost({
                      url:
                        endpoint.distributorInquiry +
                        "/update-status-and-stock-holder-save",
                      postBody: approveJSon,
                    }).then(({ data, success }) => {
                      if (success) {
                        showLoador({ loador: false });
                        if (data.data.statusCode == 500) {
                          showNotification({
                            msg: data.data.message,
                            severity: "error",
                          });
                        } else {
                          this.handleClose();
                          window.location.reload();
                          showNotification({ msg: statusmsg });
                        }
                      } else {
                        showLoador({ loador: false });
                        showNotification({
                          msg: statusFailedMsg,
                          severity: "error",
                        });
                      }
                    });
                  }
                } else {
                  showNotification({ msg: saveFailedMsg, severity: "error" });
                }

                showLoador({ loador: false });
                if (data.data.statusCode == 500) {
                  showNotification({
                    msg: data.data.message,
                    severity: "error",
                  });
                } else {
                  this.handleClose();
                  window.location.reload();
                  showNotification({ msg: statusmsg });
                }
              });
            }
          });
        } else {
          swal({
            title: "Are you sure?",
            text: convertMessage,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          }).then((willDelete) => {
            if (willDelete) {
              showLoador({ loador: true });
              saveDistributorInquiry({ dataToSave }).then(
                ({ response, success }) => {
                  showLoador({ loador: false });
                  if (success) {
                    showLoador({ loador: true });
                    apiPost({
                      url:
                        endpoint.distributorInquiry +
                        "/update-status-and-stock-holder-save",
                      postBody: approveJSon,
                    }).then(({ data, success }) => {
                      if (success) {
                        showLoador({ loador: false });
                        if (data.data.statusCode == 500) {
                          showNotification({
                            msg: data.data.message,
                            severity: "error",
                          });
                        } else {
                          this.handleClose();
                          window.location.reload();
                          showNotification({ msg: statusmsg });
                        }
                      } else {
                        showLoador({ loador: false });
                        showNotification({
                          msg: statusFailedMsg,
                          severity: "error",
                        });
                      }
                    });
                  } else {
                    showNotification({ msg: saveFailedMsg, severity: "error" });
                  }
                }
              );
            }
          });
        }
      }
    }
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData } = this.state;
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      showLoador,
      showNotification,
    } = this.props;

    if (fieldName === "currentRegionId" && newValue != "") {
      showLoador({ loador: true });
      getStateByRegion({ regionIds: newValue }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else if (fieldName === "currentStateId" && newValue != "") {
      showLoador({ loador: true });
      getZoneByState({ stateIds: newValue }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else if (fieldName === "currentZoneIds" && newValue != "") {
      showLoador({ loador: true });
      getDistrictByZone({ zoneIds: newValue }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else if (fieldName === "currentDistrictIds" && newValue != "") {
      showLoador({ loador: true });
      getTalukaByDistrict({ districtIds: newValue }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    }

    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    AddDistributorJson
      ? AddDistributorJson.fieldMetaForConvertNew
      : AddDistributorJson.fieldMetaForConvert.map((currentField) => {
        if (currentField.dataKey === fieldName && currentField.getListId) {
          const masterKeyList = currentField.getListId.split(",");

          masterKeyList.map((key) => {
            if (fieldName === key) {
              dataToSearch[key] = newValue;
            } else if (fieldData[key]) {
              dataToSearch[key] = fieldData[key];
            }
            return null;
          });
        }
        if (currentField.getListFrom) {
          const masterKeyList = currentField.getListFrom.split(",");
          masterKeyList.map((key) => {
            if (key == fieldName && dataToReset[key]) {
              delete dataToReset[currentField.dataKey];
            }
          });
        }
        return null;
      });

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  checkValidationOnSubmit = () => {
    const { fieldData, isNewArea, adminFlag, userTypeId } = this.state;

    let fieldMetaForCondition =
      adminFlag && isNewArea == 1
        ? AddDistributorJson.fieldMetaForConvertForAdmin
        : userTypeId == 3 && isNewArea == 1
          ? AddDistributorJson.fieldMetaForConvertNew
          : AddDistributorJson.fieldMetaForConvert;
    const mandatoryCheckErrors = mandatoryCheck({
      fieldData,
      fieldMeta: fieldMetaForCondition,
    });
    this.setState({
      formErrors: mandatoryCheckErrors.formErrors,
    });

    if (mandatoryCheckErrors.formValid) {
      const ValidationCheckErrors = ValidationCheck({
        fieldData,
        fieldMeta: fieldMetaForCondition,
      });
      this.setState({
        formErrors: ValidationCheckErrors.formErrors,
      });
      return ValidationCheckErrors.formValid;
    } else {
      return false;
    }
  };

  render() {
    const {
      openPopUp,
      dynamicMasterData,
      fullName,
      fieldData,
      formErrors,
      isNewArea,
      adminFlag,
      userTypeId,
    } = this.state;

    return (
      <>
        <BootstrapDialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={openPopUp}
          fullWidth
          maxWidth="lg"
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={this.handleClose}
          >
            Add Below Details
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography
              style={{
                fontSize: 18,
                color: blackColor,
                marginLeft: "9px",
              }}
            >
              {"Name :" + " " + fullName}
            </Typography>

            <Paper
              sx={{
                padding: 2,
              }}
              elevation={0}
            >
              <DynamicFormWithoutValidation
                dynamicMasterData={dynamicMasterData}
                screenTitle={""}
                fieldMeta={
                  adminFlag && isNewArea == 1
                    ? AddDistributorJson.fieldMetaForConvertForAdmin
                    : userTypeId == 3 && isNewArea == 1
                      ? AddDistributorJson.fieldMetaForConvertNew
                      : AddDistributorJson.fieldMetaForConvert
                }
                apiBaseURL={AddDistributorJson.apiBaseURL}
                formErrors={formErrors}
                showSaveBtn={false}
                showSaveBtnMain={false}
                getByIdApi={true}
                callApi={true}
                fieldData={fieldData}
                onDataChange={this.onDataChange}
                showBackToList={true}
              />

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="right"
              >
                <ButtonCompo
                  size="medium"
                  type="button"
                  variant="contained"
                  name="Save"
                  onClick={this.onSave}
                />
              </Grid>
            </Paper>
          </DialogContent>
        </BootstrapDialog>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stakeHolderTypeList: state.stockStakeHolderType,
  brandList: state.brand,
  paymentTermList: state.paymentTerm,
  distributorInquiryList: state.distributorInquiry,
  talukaList: state.taluka,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getStockStakeHolderType,
  getBrand,
  getPaymentTerm,
  saveDistributorInquiry,
  getAreaByUserType,
  getTalukaByUserType,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBody,
  getRegionNew,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ConvertDataPopUp);
